import { render, staticRenderFns } from "./workpackage-info.vue?vue&type=template&id=445710fb&scoped=true"
import script from "./workpackage-info.vue?vue&type=script&lang=js"
export * from "./workpackage-info.vue?vue&type=script&lang=js"
import style0 from "./workpackage-info.vue?vue&type=style&index=0&id=445710fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445710fb",
  null
  
)

export default component.exports